import React, { useState, useEffect } from "react";
import cc_format from "../../func/card_formatter";
import valid from "card-validator";
import icon from "/fallbacks/lock-3.svg";
const CardField = ({
  dataCy,
  placeholder,
  error,
  name,
  type,
  width,
  value,
  margin,
  max,
  setValue,
  submitCount,
  register,
  trigger,
}) => {
  function formatInputValue(name, value) {
    if (name == "card_number") {
      return cc_format(value);
    }
  }
  const [isValidationActive, setIsValidationActive] = useState(false);
  const [creditCardType, setCardType] = useState(null);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    const cardData = valid.number(value);
    if (cardData?.card?.type) {
      setCardType(cardData?.card?.type);
    } else {
      setCardType(null);
    }
  }, [value]);

  return (
    <div
      className="input-container"
      style={{
        width: width == "full" ? "100%" : `calc(${width == "half" ? 50 : width}% - 6px)`,
        marginRight: margin ? "12px" : "0px",
        backgroundColor: "transparent",
      }}
    >
      <div className={`input input--text ${error && "input--error"}`}>
        <input
          data-cy={dataCy}
          maxLength={max}
          className="styledInput"
          autoComplete="cc-number"
          type={type}
          name={name}
          {...register(name)}
          value={formatInputValue(name, value)}
          onFocus={() => {
            setIsFocused(true);
          }}
          onChange={(e) => {
            setValue(name, formatInputValue(name, e.target.value), {
              shouldValidate: isValidationActive,
              shouldTouch: true,
            });
          }}
          //
        />
        <label className={value.length > 0 ? "styledLabel styledLabel--active" : "styledLabel"}>{placeholder}</label>
        <div
          className="input__img"
          style={{
            width: creditCardType ? "24px" : "16px",
            height: creditCardType ? "24px" : "16px",
            backgroundSize: "contain",
            backgroundImage: `url(${
              creditCardType ? window.template_root + "checkout-V4/src/public/cards/" + creditCardType + ".svg" : icon
            })`,
          }}
        ></div>
      </div>
      {error && <span className="formError">{error}</span>}
    </div>
  );
};

export default CardField;
